<template>
  <div class="p-4 md:p-6">
    <!-- Encabezado -->
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
      <div>
        <h1 class="text-2xl font-bold text-gray-800 dark:text-white">Gestión de Métodos de Pago</h1>
        <p class="text-sm md:text-base text-gray-600 dark:text-gray-400">Administra las formas de pago disponibles</p>
      </div>
      <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 w-full md:w-auto">
        <!-- BOTÓN DE REPORTE GENERAL -->
        <button
          @click="generarReporteGeneral"
          class="flex items-center justify-center px-3 py-2 md:px-4 md:py-2.5 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg hover:from-green-700 hover:to-emerald-700 transition-all duration-300 shadow-md hover:shadow-lg text-sm md:text-base"
        >
          <Icon icon="mdi:file-document" class="mr-2 text-lg" />
          <span class="hidden sm:inline">Reporte General</span>
          <span class="sm:hidden">Reporte</span>
        </button>

        <!-- BOTÓN NUEVO MÉTODO DE PAGO -->
        <button
          @click="openCreateModal"
          class="flex items-center justify-center px-3 py-2 md:px-4 md:py-2.5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 shadow-md hover:shadow-lg text-sm md:text-base"
        >
          <Icon icon="mdi:plus" class="mr-2 text-lg" />
          <span class="hidden sm:inline">Nuevo Método</span>
          <span class="sm:hidden">Nuevo</span>
        </button>
      </div>
    </div>

    <!-- Filtros y búsqueda -->
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-sm p-3 mb-4 border border-gray-200 dark:border-gray-700">
      <div class="grid grid-cols-12 gap-2">
        <div class="col-span-12 md:col-span-4">
          <label class="block text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">Buscar Métodos de Pago</label>
          <div class="relative">
            <Icon icon="mdi:magnify" class="absolute left-2.5 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
            <input v-model="searchQuery" type="text" placeholder="Nombre, tipo, descripción..."
              class="w-full pl-8 pr-3 py-1.5 border border-gray-200 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 focus:border-transparent text-xs transition-all"
              @input="handleSearch" />
          </div>
        </div>
        <div class="col-span-6 md:col-span-2">
          <label class="block text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">Estado</label>
          <div class="relative">
            <select v-model="filterStatus" @change="handleFilterChange"
              class="w-full appearance-none border border-gray-200 dark:border-gray-600 rounded-lg px-2.5 py-1.5 bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 pr-7 text-xs transition-all">
              <option value="all">Todos</option>
              <option value="activos">Activos</option>
              <option value="inactivos">Inactivos</option>
            </select>
            <Icon icon="mdi:chevron-down" class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none text-sm" />
          </div>
        </div>
        <div class="col-span-6 md:col-span-3">
          <label class="block text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">Tipo</label>
          <div class="relative">
            <select v-model="filterTipo"
              class="w-full appearance-none border border-gray-200 dark:border-gray-600 rounded-lg px-2.5 py-1.5 bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 pr-7 text-xs transition-all">
              <option value="all">Todos los tipos</option>
              <option v-for="tipo in tiposDisponibles" :key="tipo" :value="tipo">{{ formatTipo(tipo) }}</option>
            </select>
            <Icon icon="mdi:chevron-down" class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none text-sm" />
          </div>
        </div>
        <div class="col-span-6 md:col-span-3">
          <label class="block text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase tracking-wider mb-1">Moneda</label>
          <div class="relative">
            <select v-model="filterMoneda"
              class="w-full appearance-none border border-gray-200 dark:border-gray-600 rounded-lg px-2.5 py-1.5 bg-white dark:bg-gray-700 focus:ring-2 focus:ring-blue-500 pr-7 text-xs transition-all">
              <option value="all">Todas las monedas</option>
              <option value="USD">Solo USD</option>
              <option value="VES">Solo VES</option>
              <option value="USDT">Solo USDT</option>
            </select>
            <Icon icon="mdi:chevron-down" class="absolute right-2 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none text-sm" />
          </div>
        </div>
      </div>

      <!-- BOTONES DE REPORTES POR FILTRO -->
      <div class="mt-4 pt-4 border-t border-gray-200 dark:border-gray-700 flex flex-wrap gap-2">
        <span class="text-sm font-medium text-gray-700 dark:text-gray-300 mr-2 py-2">Reportes rápidos:</span>
        
        <button
          @click="generarReportePorFiltro('activos', 'MÉTODOS DE PAGO ACTIVOS')"
          class="px-3 py-1.5 bg-green-50 dark:bg-green-900/30 text-green-700 dark:text-green-300 rounded-lg text-xs font-medium hover:bg-green-100 dark:hover:bg-green-800/50 transition-colors border border-green-200 dark:border-green-800"
        >
          <Icon icon="mdi:check-circle" class="mr-1 inline" /> Activos
        </button>
        
        <button
          @click="generarReportePorFiltro('inactivos', 'MÉTODOS DE PAGO INACTIVOS')"
          class="px-3 py-1.5 bg-red-50 dark:bg-red-900/30 text-red-700 dark:text-red-300 rounded-lg text-xs font-medium hover:bg-red-100 dark:hover:bg-red-800/50 transition-colors border border-red-200 dark:border-red-800"
        >
          <Icon icon="mdi:close-circle" class="mr-1 inline" /> Inactivos
        </button>
        
        <button
          @click="generarReportePorFiltro('efectivo', 'MÉTODOS DE PAGO EN EFECTIVO')"
          class="px-3 py-1.5 bg-blue-50 dark:bg-blue-900/30 text-blue-700 dark:text-blue-300 rounded-lg text-xs font-medium hover:bg-blue-100 dark:hover:bg-blue-800/50 transition-colors border border-blue-200 dark:border-blue-800"
        >
          <Icon icon="mdi:cash" class="mr-1 inline" /> Efectivo
        </button>
        
        <button
          @click="generarReportePorFiltro('transferencia', 'TRANSFERENCIAS BANCARIAS')"
          class="px-3 py-1.5 bg-purple-50 dark:bg-purple-900/30 text-purple-700 dark:text-purple-300 rounded-lg text-xs font-medium hover:bg-purple-100 dark:hover:bg-purple-800/50 transition-colors border border-purple-200 dark:border-purple-800"
        >
          <Icon icon="mdi:bank-transfer" class="mr-1 inline" /> Transferencias
        </button>
        
        <button
          @click="generarReportePorFiltro('tarjeta', 'TARJETAS DE CRÉDITO/DÉBITO')"
          class="px-3 py-1.5 bg-amber-50 dark:bg-amber-900/30 text-amber-700 dark:text-amber-300 rounded-lg text-xs font-medium hover:bg-amber-100 dark:hover:bg-amber-800/50 transition-colors border border-amber-200 dark:border-amber-800"
        >
          <Icon icon="mdi:credit-card" class="mr-1 inline" /> Tarjetas
        </button>
        
        <button
          @click="generarReportePorFiltro('cripto', 'CRIPTOMONEDAS')"
          class="px-3 py-1.5 bg-indigo-50 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300 rounded-lg text-xs font-medium hover:bg-indigo-100 dark:hover:bg-indigo-800/50 transition-colors border border-indigo-200 dark:border-indigo-800"
        >
          <Icon icon="mdi:bitcoin" class="mr-1 inline" /> Cripto
        </button>
      </div>
    </div>

    <!-- GRID DE MÉTODOS DE PAGO -->
    <div class="bg-white dark:bg-gray-800 rounded-xl shadow-md overflow-hidden border border-gray-200 dark:border-gray-700">
      <div class="px-4 md:px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
        <div>
          <h2 class="text-base md:text-lg font-semibold text-gray-800 dark:text-white">Lista de Métodos de Pago</h2>
          <p class="text-xs md:text-sm text-gray-600 dark:text-gray-400">
            Mostrando {{ Math.min(paginatedMetodos.length, itemsPerPage) }} de {{ filteredMetodos.length }} métodos
          </p>
        </div>
        <div class="flex items-center space-x-2 text-xs md:text-sm text-gray-500 dark:text-gray-400">
          <Icon icon="mdi:calendar" class="inline mr-1 text-sm" />
          <span class="hidden xs:inline">Última actualización:</span> {{ formatTime(lastUpdate) }}
        </div>
      </div>

      <div v-if="loading" class="py-12 md:py-16">
        <div class="flex flex-col items-center justify-center">
          <div class="animate-spin rounded-full h-10 w-10 md:h-12 md:w-12 border-t-2 border-b-2 border-blue-600 mb-4"></div>
          <p class="text-sm md:text-base text-gray-600 dark:text-gray-400">Cargando métodos de pago...</p>
        </div>
      </div>

      <div v-else-if="filteredMetodos.length === 0" class="py-12 md:py-16 px-4">
        <div class="flex flex-col items-center text-center">
          <div class="p-4 bg-gray-100 dark:bg-gray-700 rounded-full mb-4">
            <Icon icon="mdi:cash-off" class="text-3xl md:text-4xl text-gray-400" />
          </div>
          <h3 class="text-base md:text-lg font-medium text-gray-800 dark:text-white mb-2">
            No se encontraron métodos de pago
          </h3>
          <p class="text-xs md:text-sm text-gray-600 dark:text-gray-400 mb-6 max-w-md">
            {{ searchQuery || filterStatus !== 'all' || filterTipo !== 'all' || filterMoneda !== 'all'
              ? 'Intenta con otros términos de búsqueda o cambia los filtros.' 
              : 'No hay métodos de pago registrados. ¡Registra el primero!' }}
          </p>
          <button
            v-if="!searchQuery && filterStatus === 'all' && filterTipo === 'all' && filterMoneda === 'all'"
            @click="openCreateModal"
            class="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors text-sm"
          >
            <Icon icon="mdi:plus" class="mr-2 inline" />
            Registrar primer método
          </button>
          <button
            v-else
            @click="clearFilters"
            class="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-gray-700 dark:text-gray-300 rounded-lg hover:bg-gray-300 dark:hover:bg-gray-600 transition-colors text-sm"
          >
            <Icon icon="mdi:filter-off" class="mr-2 inline" />
            Limpiar filtros
          </button>
        </div>
      </div>

      <div v-else class="p-4 md:p-6">
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          <div 
            v-for="metodo in paginatedMetodos" 
            :key="metodo.idMetodoPago"
            class="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden"
          >
            <div class="relative h-24 sm:h-28 md:h-32 bg-gradient-to-r" :class="getTipoColor(metodo.tipo)">
              <span
                @click="abrirModalToggleStatus(metodo)"
                :class="[
                  'absolute top-3 right-3 z-10 px-2 py-1 text-xs font-semibold rounded-full shadow-sm cursor-pointer',
                  metodo.estado?.toLowerCase() === 'activo'
                    ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                    : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                ]"
              >
                <Icon :icon="metodo.estado?.toLowerCase() === 'activo' ? 'mdi:check-circle' : 'mdi:close-circle'" class="mr-1 inline text-xs" />
                {{ metodo.estado === 'Activo' ? 'Activo' : 'Inactivo' }}
              </span>

              <div class="absolute inset-0 flex items-center justify-center">
                <Icon :icon="getTipoIcon(metodo.tipo)" class="text-5xl md:text-6xl text-white opacity-30" />
              </div>

              <div class="absolute bottom-3 left-3">
                <span class="px-2 py-1 bg-white/20 backdrop-blur-sm text-white text-xs font-semibold rounded-full">
                  {{ formatTipo(metodo.tipo) }}
                </span>
              </div>
            </div>

            <div class="p-3 md:p-4">
              <h3 class="text-sm md:text-base font-semibold text-gray-900 dark:text-white mb-1">
                {{ metodo.nombre }}
              </h3>
              
              <p v-if="metodo.descripcion" class="text-xs text-gray-500 dark:text-gray-400 mb-3 line-clamp-2">
                {{ metodo.descripcion }}
              </p>

              <!-- Monedas aceptadas -->
              <div class="flex flex-wrap gap-1 mb-3">
                <span v-if="metodo.acepta_dolares" class="px-2 py-0.5 bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200 text-xs rounded-full flex items-center">
                  <Icon icon="mdi:currency-usd" class="mr-1 text-xs" /> USD
                </span>
                <span v-if="metodo.acepta_bolivares" class="px-2 py-0.5 bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200 text-xs rounded-full flex items-center">
                  <Icon icon="mdi:currency-brl" class="mr-1 text-xs" /> VES
                </span>
                <span v-if="metodo.acepta_usdt" class="px-2 py-0.5 bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-200 text-xs rounded-full flex items-center">
                  <Icon icon="mdi:currency-btc" class="mr-1 text-xs" /> USDT
                </span>
              </div>

              <!-- Campos requeridos (si existen) -->
              <div v-if="metodo.campos_requeridos" class="mb-3 p-2 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <p class="text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Campos requeridos:</p>
                <div class="flex flex-wrap gap-1">
                  <span 
                    v-for="(campo, index) in getCamposRequeridosArray(metodo.campos_requeridos)" 
                    :key="index"
                    class="text-xs bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-300 px-2 py-0.5 rounded-full"
                  >
                    {{ campo }}
                  </span>
                </div>
              </div>

              <div class="text-xs text-gray-500 dark:text-gray-400 mb-4">
                <div class="flex items-center">
                  <Icon icon="mdi:calendar" class="mr-1.5 text-sm" />
                  <span>Creado: {{ formatDate(metodo.fecha_creacion, false) }}</span>
                </div>
              </div>

              <div class="flex items-center justify-between pt-3 border-t border-gray-200 dark:border-gray-700">
                <div class="flex items-center space-x-1">
                  <button
                    @click.stop="openEditModal(metodo)"
                    class="p-2 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-lg hover:bg-blue-100 dark:hover:bg-blue-800/50 transition-colors"
                    title="Editar"
                  >
                    <Icon icon="mdi:pencil" class="text-base md:text-lg" />
                  </button>
                  <button
                    @click.stop="abrirModalVerDetalles(metodo)"
                    class="p-2 bg-purple-50 dark:bg-purple-900/30 text-purple-600 dark:text-purple-400 rounded-lg hover:bg-purple-100 dark:hover:bg-purple-800/50 transition-colors"
                    title="Ver detalles"
                  >
                    <Icon icon="mdi:eye" class="text-base md:text-lg" />
                  </button>
                  <button
                    @click.stop="abrirModalEliminar(metodo)"
                    class="p-2 bg-red-50 dark:bg-red-900/30 text-red-600 dark:text-red-400 rounded-lg hover:bg-red-100 dark:hover:bg-red-800/50 transition-colors"
                    title="Eliminar"
                  >
                    <Icon icon="mdi:delete" class="text-base md:text-lg" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Paginación Premium -->
        <div v-if="filteredMetodos.length > itemsPerPage" class="mt-4 pt-3 border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <div class="text-xs text-gray-500 dark:text-gray-400 order-2 sm:order-1">
            Mostrando <span class="font-semibold text-gray-700 dark:text-gray-300">{{ startItem }}–{{ Math.min(endItem, filteredMetodos.length) }}</span> de <span class="font-semibold text-gray-700 dark:text-gray-300">{{ filteredMetodos.length }}</span>
          </div>
          <div class="flex items-center gap-1 order-1 sm:order-2">
            <button @click="currentPage = Math.max(currentPage - 1, 1)" :disabled="currentPage === 1"
              class="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-600 text-gray-500 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-all">
              <Icon icon="mdi:chevron-left" class="text-base" />
            </button>
            <button v-for="page in visiblePages" :key="page" @click="currentPage = page"
              :class="['w-8 h-8 flex items-center justify-center rounded-lg text-xs font-semibold transition-all',
                currentPage === page
                  ? 'bg-blue-600 text-white shadow-sm shadow-blue-300 dark:shadow-blue-900'
                  : 'border border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700']">{{ page }}</button>
            <button @click="currentPage = Math.min(currentPage + 1, totalPages)" :disabled="currentPage === totalPages"
              class="w-8 h-8 flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-600 text-gray-500 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-all">
              <Icon icon="mdi:chevron-right" class="text-base" />
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- MODAL PARA CREAR/EDITAR MÉTODO DE PAGO -->
    <Teleport to="body">
    <div v-if="showModal" class="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-[90] backdrop-blur-[2px]">
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-2xl transform transition-all duration-300 scale-100 max-h-[90vh] overflow-hidden mx-auto my-auto">
        <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700">
          <div class="flex items-center justify-between">
            <div class="flex items-center">
              <div class="p-2 rounded-xl bg-gradient-to-r from-purple-500 to-indigo-500 shadow-md mr-3">
                <Icon :icon="editingMetodo ? 'mdi:pencil-box' : 'mdi:cash-plus'" class="text-white text-xl" />
              </div>
              <div>
                <h3 class="text-lg font-bold text-gray-900 dark:text-white">
                  {{ editingMetodo ? 'Editar Método de Pago' : 'Nuevo Método de Pago' }}
                </h3>
                <p class="text-xs text-gray-600 dark:text-gray-400">
                  {{ editingMetodo ? 'Modifica los datos del método de pago' : 'Completa los datos para registrar un nuevo método de pago' }}
                </p>
              </div>
            </div>
            <button 
              @click="closeModal"
              class="p-2 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
            >
              <Icon icon="mdi:close" class="text-xl" />
            </button>
          </div>
        </div>
        
        <form @submit.prevent="saveMetodoPago" class="px-6 py-4 overflow-y-auto max-h-[calc(90vh-130px)]">
          <div class="space-y-4">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Nombre <span class="text-red-500">*</span>
                </label>
                <input
                  v-model="form.nombre"
                  type="text"
                  required
                  maxlength="100"
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
                  placeholder="Ej: Transferencia Bancaria"
                />
              </div>
              
              <div>
                <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                  Tipo <span class="text-red-500">*</span>
                </label>
                <select
                  v-model="form.tipo"
                  required
                  class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 text-sm"
                >
                  <option value="">Seleccionar tipo...</option>
                  <option value="efectivo">Efectivo</option>
                  <option value="transferencia">Transferencia Bancaria</option>
                  <option value="pago_movil">Pago Móvil</option>
                  <option value="tarjeta">Tarjeta (Punto de Venta)</option>
                  <option value="transferencia_internacional">Transferencia Internacional</option>
                  <option value="cripto">Criptomoneda</option>
                  <option value="aplicacion_credito">Aplicación de Crédito</option>
                </select>
                <p v-if="errors.tipo" class="mt-1 text-xs text-red-600">{{ errors.tipo }}</p>
              </div>
            </div>
            
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Descripción
              </label>
              <textarea
                v-model="form.descripcion"
                rows="2"
                maxlength="500"
                class="w-full px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:border-blue-500 focus:ring-2 focus:ring-blue-500/20 focus:outline-none transition-all duration-300 resize-none text-sm"
                placeholder="Descripción del método de pago..."
              ></textarea>
            </div>
            
            <!-- Monedas aceptadas -->
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Monedas aceptadas <span class="text-red-500">*</span>
              </label>
              <div class="grid grid-cols-1 md:grid-cols-3 gap-3">
                <label class="flex items-center space-x-2 p-3 border border-gray-200 dark:border-gray-700 rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700">
                  <input type="checkbox" v-model="form.acepta_dolares" class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                  <Icon icon="mdi:currency-usd" class="text-green-600 text-lg" />
                  <span class="text-sm">Dólares (USD)</span>
                </label>
                
                <label class="flex items-center space-x-2 p-3 border border-gray-200 dark:border-gray-700 rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700">
                  <input type="checkbox" v-model="form.acepta_bolivares" class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                  <Icon icon="mdi:currency-brl" class="text-blue-600 text-lg" />
                  <span class="text-sm">Bolívares (VES)</span>
                </label>
                
                <label class="flex items-center space-x-2 p-3 border border-gray-200 dark:border-gray-700 rounded-lg cursor-pointer hover:bg-gray-50 dark:hover:bg-gray-700">
                  <input type="checkbox" v-model="form.acepta_usdt" class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                  <Icon icon="mdi:currency-btc" class="text-purple-600 text-lg" />
                  <span class="text-sm">USDT (Cripto)</span>
                </label>
              </div>
              <p v-if="errors.monedas" class="mt-1 text-xs text-red-600">{{ errors.monedas }}</p>
            </div>
            
            <!-- Campos requeridos -->
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
                Campos requeridos (opcional)
              </label>
              <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
                <label class="flex items-center space-x-2">
                  <input type="checkbox" v-model="camposSeleccionados.referencia" class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                  <span class="text-sm">Número de referencia</span>
                </label>
                <label class="flex items-center space-x-2">
                  <input type="checkbox" v-model="camposSeleccionados.banco_origen" class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                  <span class="text-sm">Banco origen</span>
                </label>
                <label class="flex items-center space-x-2">
                  <input type="checkbox" v-model="camposSeleccionados.banco_destino" class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                  <span class="text-sm">Banco destino</span>
                </label>
                <label class="flex items-center space-x-2">
                  <input type="checkbox" v-model="camposSeleccionados.numero_cuenta" class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                  <span class="text-sm">Número de cuenta</span>
                </label>
                <label class="flex items-center space-x-2">
                  <input type="checkbox" v-model="camposSeleccionados.cedula_titular" class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                  <span class="text-sm">Cédula del titular</span>
                </label>
                <label class="flex items-center space-x-2">
                  <input type="checkbox" v-model="camposSeleccionados.nombre_titular" class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                  <span class="text-sm">Nombre del titular</span>
                </label>
                <label class="flex items-center space-x-2">
                  <input type="checkbox" v-model="camposSeleccionados.telefono" class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                  <span class="text-sm">Teléfono</span>
                </label>
                <label class="flex items-center space-x-2">
                  <input type="checkbox" v-model="camposSeleccionados.email" class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                  <span class="text-sm">Email</span>
                </label>
                <label class="flex items-center space-x-2">
                  <input type="checkbox" v-model="camposSeleccionados.wallet_address" class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                  <span class="text-sm">Wallet address</span>
                </label>
                <label class="flex items-center space-x-2">
                  <input type="checkbox" v-model="camposSeleccionados.red_blockchain" class="rounded border-gray-300 text-blue-600 focus:ring-blue-500">
                  <span class="text-sm">Red blockchain</span>
                </label>
              </div>
            </div>
            
            <div>
              <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Estado
              </label>
              <div class="flex space-x-4">
                <label class="flex items-center">
                  <input type="radio" v-model="form.estado" value="Activo" class="mr-2">
                  <span class="text-sm">Activo</span>
                </label>
                <label class="flex items-center">
                  <input type="radio" v-model="form.estado" value="Inactivo" class="mr-2">
                  <span class="text-sm">Inactivo</span>
                </label>
              </div>
            </div>
          </div>
          
          <div class="mt-6 flex justify-end space-x-3">
            <button
              type="button"
              @click="closeModal"
              class="px-4 py-2.5 border-2 border-gray-300 dark:border-gray-600 rounded-xl text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-300 text-sm"
            >
              Cancelar
            </button>
            <button
              type="submit"
              :disabled="saving || !isFormValid"
              class="px-4 py-2.5 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-xl font-medium hover:from-blue-700 hover:to-indigo-700 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed text-sm"
            >
              <Icon v-if="saving" icon="mdi:loading" class="animate-spin mr-2 inline" />
              {{ saving ? 'Guardando...' : (editingMetodo ? 'Actualizar' : 'Crear') }}
            </button>
          </div>
        </form>
      </div>
    </div>
    </Teleport>

    <!-- MODAL DE DETALLES DEL MÉTODO DE PAGO -->
    <Teleport to="body">
    <div v-if="showDetallesModal" class="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-[90] backdrop-blur-[2px]">
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-2xl transform transition-all duration-300 scale-100 max-h-[90vh] overflow-hidden mx-auto my-auto">
        <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-purple-600 to-indigo-600">
          <div class="flex items-center justify-between">
            <div class="flex items-center text-white">
              <Icon :icon="getTipoIcon(detalleMetodo?.tipo)" class="text-2xl mr-3" />
              <div>
                <h3 class="text-lg font-bold">{{ detalleMetodo?.nombre }}</h3>
                <p class="text-xs text-purple-100">{{ formatTipo(detalleMetodo?.tipo) }}</p>
              </div>
            </div>
            <button @click="closeDetallesModal" class="p-2 hover:bg-white/30 text-white rounded-lg transition-colors">
              <Icon icon="mdi:close" class="text-xl" />
            </button>
          </div>
        </div>

        <div class="px-6 py-4 overflow-y-auto max-h-[calc(90vh-130px)]">
          <div v-if="cargandoDetalles" class="flex justify-center py-8">
            <div class="animate-spin rounded-full h-8 w-8 border-2 border-blue-600 border-t-transparent"></div>
          </div>
          <div v-else-if="detalleMetodo" class="space-y-4">
            <!-- Información básica -->
            <div class="grid grid-cols-2 gap-4">
              <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <p class="text-xs text-gray-500 dark:text-gray-400">ID</p>
                <p class="text-sm font-semibold">{{ detalleMetodo.idMetodoPago }}</p>
              </div>
              <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
                <p class="text-xs text-gray-500 dark:text-gray-400">Estado</p>
                <p class="text-sm">
                  <span :class="[
                    'px-2 py-1 text-xs font-semibold rounded-full inline-block',
                    detalleMetodo.estado === 'Activo' 
                      ? 'bg-green-100 text-green-800' 
                      : 'bg-red-100 text-red-800'
                  ]">
                    {{ detalleMetodo.estado }}
                  </span>
                </p>
              </div>
            </div>

            <!-- Descripción -->
            <div v-if="detalleMetodo.descripcion" class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-1">Descripción</p>
              <p class="text-sm">{{ detalleMetodo.descripcion }}</p>
            </div>

            <!-- Monedas aceptadas -->
            <div class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">Monedas aceptadas</p>
              <div class="flex flex-wrap gap-2">
                <span v-if="detalleMetodo.acepta_dolares" class="px-3 py-1 bg-green-100 dark:bg-green-900/30 text-green-800 dark:text-green-200 rounded-full text-xs flex items-center">
                  <Icon icon="mdi:currency-usd" class="mr-1" /> Dólares (USD)
                </span>
                <span v-if="detalleMetodo.acepta_bolivares" class="px-3 py-1 bg-blue-100 dark:bg-blue-900/30 text-blue-800 dark:text-blue-200 rounded-full text-xs flex items-center">
                  <Icon icon="mdi:currency-brl" class="mr-1" /> Bolívares (VES)
                </span>
                <span v-if="detalleMetodo.acepta_usdt" class="px-3 py-1 bg-purple-100 dark:bg-purple-900/30 text-purple-800 dark:text-purple-200 rounded-full text-xs flex items-center">
                  <Icon icon="mdi:currency-btc" class="mr-1" /> USDT
                </span>
              </div>
            </div>

            <!-- Campos requeridos -->
            <div v-if="detalleMetodo.campos_requeridos" class="p-3 bg-gray-50 dark:bg-gray-700 rounded-lg">
              <p class="text-xs text-gray-500 dark:text-gray-400 mb-2">Campos requeridos</p>
              <div class="grid grid-cols-2 gap-2">
                <div 
                  v-for="(campo, index) in getCamposRequeridosArray(detalleMetodo.campos_requeridos)" 
                  :key="index"
                  class="flex items-center text-sm"
                >
                  <Icon icon="mdi:check-circle" class="text-green-600 mr-1 text-sm" />
                  {{ campo }}
                </div>
              </div>
            </div>

            <!-- Estadísticas (si están disponibles) -->
            <div v-if="detalleEstadisticas" class="border-t border-gray-200 dark:border-gray-700 pt-4 mt-2">
              <h4 class="text-sm font-semibold text-gray-800 dark:text-white mb-3">Estadísticas de uso</h4>
              <div class="grid grid-cols-2 gap-4">
                <div class="text-center p-3 bg-blue-50 dark:bg-blue-900/20 rounded-lg">
                  <p class="text-2xl font-bold text-blue-600 dark:text-blue-400">{{ detalleEstadisticas.TotalPagos || 0 }}</p>
                  <p class="text-xs text-gray-600 dark:text-gray-400">Total de pagos</p>
                </div>
                <div class="text-center p-3 bg-green-50 dark:bg-green-900/20 rounded-lg">
                  <p class="text-2xl font-bold text-green-600 dark:text-green-400">{{ formatNumber(detalleEstadisticas.MontoTotalPagos, 2) }}$</p>
                  <p class="text-xs text-gray-600 dark:text-gray-400">Monto total</p>
                </div>
              </div>
              
              <div class="mt-3 grid grid-cols-3 gap-2 text-xs">
                <div class="p-2 bg-gray-100 dark:bg-gray-700 rounded text-center">
                  <p class="font-semibold">{{ formatNumber(detalleEstadisticas.MontoTotalDolares, 2) }}$</p>
                  <p class="text-gray-500">USD</p>
                </div>
                <div class="p-2 bg-gray-100 dark:bg-gray-700 rounded text-center">
                  <p class="font-semibold">{{ formatNumber(detalleEstadisticas.MontoTotalBolivares, 2) }} Bs</p>
                  <p class="text-gray-500">VES</p>
                </div>
                <div class="p-2 bg-gray-100 dark:bg-gray-700 rounded text-center">
                  <p class="font-semibold">{{ formatNumber(detalleEstadisticas.MontoTotalUSDT, 2) }}$</p>
                  <p class="text-gray-500">USDT</p>
                </div>
              </div>
              
              <div class="mt-3 text-xs text-gray-500 dark:text-gray-400">
                <p>Último pago: {{ detalleEstadisticas.UltimoPago ? formatDate(detalleEstadisticas.UltimoPago, true) : 'Sin pagos' }}</p>
                <p>Pagos último mes: {{ detalleEstadisticas.PagosUltimoMes || 0 }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 flex justify-end">
          <button
            @click="closeDetallesModal"
            class="px-4 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-100 dark:hover:bg-gray-700 transition-all duration-300 text-sm"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
    </Teleport>

    <!-- MODAL DE REPORTE -->
    <Teleport to="body">
    <div v-if="showReportModal" class="fixed inset-0 bg-black/80 flex items-center justify-center p-4 z-[100] backdrop-blur-[2px]" @click.self="closeReportModal">
      <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-2xl w-full max-w-6xl transform transition-all duration-300 scale-100 max-h-[95vh] overflow-hidden mx-auto my-auto flex flex-col">
        <div class="px-6 py-4 border-b border-gray-200 dark:border-gray-700 bg-gradient-to-r from-green-600 to-emerald-600 flex justify-between items-center">
          <div class="flex items-center text-white">
            <Icon icon="mdi:file-document" class="text-2xl mr-3" />
            <div>
              <h3 class="text-xl font-bold">{{ reporteTitulo }}</h3>
              <p class="text-xs text-green-100">{{ reporteSubtitulo }} • {{ reporteMetodos.length }} métodos</p>
            </div>
          </div>
          <button @click="closeReportModal" class="p-2 hover:bg-white/30 text-white rounded-lg transition-colors">
            <Icon icon="mdi:close" class="text-2xl" />
          </button>
        </div>

        <div class="px-6 pt-4 border-b border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800">
          <div class="flex space-x-4">
            <button
              @click="reporteVista = 'lista'"
              :class="[
                'px-4 py-2 text-sm font-medium rounded-t-lg transition-colors',
                reporteVista === 'lista'
                  ? 'bg-white dark:bg-gray-900 text-green-600 dark:text-green-400 border-b-2 border-green-600'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              ]"
            >
              <Icon icon="mdi:format-list-bulleted" class="mr-2 inline" />
              Vista Lista
            </button>
            <button
              @click="reporteVista = 'tarjetas'"
              :class="[
                'px-4 py-2 text-sm font-medium rounded-t-lg transition-colors',
                reporteVista === 'tarjetas'
                  ? 'bg-white dark:bg-gray-900 text-green-600 dark:text-green-400 border-b-2 border-green-600'
                  : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
              ]"
            >
              <Icon icon="mdi:card-multiple" class="mr-2 inline" />
              Vista Tarjetas
            </button>
          </div>
        </div>

        <div class="flex-1 overflow-y-auto p-6 bg-gray-50 dark:bg-gray-800">
          <div v-if="reporteCargando" class="flex items-center justify-center py-20">
            <div class="animate-spin rounded-full h-12 w-12 border-4 border-green-600 border-t-transparent"></div>
            <p class="ml-4 text-gray-600 dark:text-gray-400">Generando reporte...</p>
          </div>
          <div v-else-if="reporteMetodos.length === 0" class="text-center py-20 text-gray-500">
            No hay métodos de pago para mostrar en este reporte.
          </div>
          <div v-else>
            <div v-if="reporteVista === 'lista'" class="bg-white dark:bg-gray-900 rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
              <table class="w-full text-sm">
                <thead class="bg-gray-100 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700">
                  <tr>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Nombre</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Tipo</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Monedas</th>
                    <th class="px-4 py-3 text-left text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Campos requeridos</th>
                    <th class="px-4 py-3 text-center text-xs font-medium text-gray-600 dark:text-gray-400 uppercase tracking-wider">Estado</th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-200 dark:divide-gray-700">
                  <tr v-for="metodo in reporteMetodos" :key="metodo.idMetodoPago" class="hover:bg-gray-50 dark:hover:bg-gray-800/50">
                    <td class="px-4 py-3">
                      <div class="font-medium">{{ metodo.nombre }}</div>
                      <div class="text-xs text-gray-500">{{ metodo.descripcion || '—' }}</div>
                    </td>
                    <td class="px-4 py-3">
                      <span class="px-2 py-1 bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200 rounded-full text-xs">
                        {{ formatTipo(metodo.tipo) }}
                      </span>
                    </td>
                    <td class="px-4 py-3">
                      <div class="flex gap-1">
                        <span v-if="metodo.acepta_dolares" class="w-6 h-6 rounded-full bg-green-100 text-green-800 flex items-center justify-center text-xs" title="USD">$</span>
                        <span v-if="metodo.acepta_bolivares" class="w-6 h-6 rounded-full bg-blue-100 text-blue-800 flex items-center justify-center text-xs" title="VES">Bs</span>
                        <span v-if="metodo.acepta_usdt" class="w-6 h-6 rounded-full bg-purple-100 text-purple-800 flex items-center justify-center text-xs" title="USDT">₮</span>
                      </div>
                    </td>
                    <td class="px-4 py-3">
                      <div v-if="metodo.campos_requeridos" class="flex flex-wrap gap-1">
                        <span 
                          v-for="(campo, index) in getCamposRequeridosArray(metodo.campos_requeridos).slice(0, 2)" 
                          :key="index"
                          class="text-xs bg-gray-200 dark:bg-gray-600 text-gray-700 dark:text-gray-300 px-2 py-0.5 rounded-full"
                        >
                          {{ campo }}
                        </span>
                        <span v-if="getCamposRequeridosArray(metodo.campos_requeridos).length > 2" class="text-xs text-gray-500">
                          +{{ getCamposRequeridosArray(metodo.campos_requeridos).length - 2 }}
                        </span>
                      </div>
                      <span v-else class="text-xs text-gray-400">—</span>
                    </td>
                    <td class="px-4 py-3 text-center">
                      <span :class="[
                        'px-2 py-1 text-xs font-semibold rounded-full',
                        metodo.estado === 'Activo' 
                          ? 'bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-200'
                          : 'bg-red-100 text-red-800 dark:bg-red-900 dark:text-red-200'
                      ]">
                        {{ metodo.estado }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div v-else class="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
              <div
                v-for="metodo in reporteMetodos"
                :key="metodo.idMetodoPago"
                class="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm hover:shadow-md transition-all"
              >
                <div class="flex justify-between items-start">
                  <div>
                    <h4 class="font-semibold text-gray-800 dark:text-white">{{ metodo.nombre }}</h4>
                    <p class="text-xs text-gray-500 dark:text-gray-400">{{ formatTipo(metodo.tipo) }}</p>
                  </div>
                  <span
                    :class="[
                      'px-2 py-1 text-xs font-semibold rounded-full',
                      metodo.estado === 'Activo' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                    ]"
                  >
                    {{ metodo.estado }}
                  </span>
                </div>
                <div class="mt-3">
                  <div class="flex gap-1 mb-2">
                    <span v-if="metodo.acepta_dolares" class="px-2 py-1 bg-green-100 text-green-800 rounded text-xs">USD</span>
                    <span v-if="metodo.acepta_bolivares" class="px-2 py-1 bg-blue-100 text-blue-800 rounded text-xs">VES</span>
                    <span v-if="metodo.acepta_usdt" class="px-2 py-1 bg-purple-100 text-purple-800 rounded text-xs">USDT</span>
                  </div>
                  <p v-if="metodo.descripcion" class="text-xs text-gray-500 dark:text-gray-400 line-clamp-2">{{ metodo.descripcion }}</p>
                </div>
              </div>
            </div>

            <div class="mt-4 text-right text-sm text-gray-600 dark:text-gray-400">
              Total de métodos: <span class="font-bold">{{ reporteMetodos.length }}</span>
            </div>
          </div>
        </div>

        <div class="px-6 py-4 border-t border-gray-200 dark:border-gray-700 bg-gray-50 dark:bg-gray-800 flex justify-between items-center">
          <div class="text-xs text-gray-500">
            <Icon icon="mdi:information" class="inline mr-1" />
            Puedes cambiar entre vista lista y vista tarjetas
          </div>
          <div class="flex space-x-3">
            <button
              @click="closeReportModal"
              class="px-4 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-100 dark:hover:bg-gray-700 transition-all duration-300 text-sm"
            >
              Cerrar
            </button>
            <button
              @click="imprimirReporte"
              class="px-4 py-2 bg-gradient-to-r from-green-600 to-emerald-600 text-white rounded-lg font-medium hover:from-green-700 hover:to-emerald-700 transition-all duration-300 text-sm flex items-center"
            >
              <Icon icon="mdi:printer" class="mr-2 text-lg" />
              Imprimir
            </button>
          </div>
        </div>
      </div>
    </div>
    </Teleport>

    <!-- MODAL DE CONFIRMACIÓN -->
    <Teleport to="body">
    <div v-if="showConfirmModal" class="fixed inset-0 bg-black/70 flex items-center justify-center p-4 z-[110] backdrop-blur-[2px]" @click.self="cancelarConfirmacion">
      <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md transform transition-all duration-300 scale-100 mx-auto my-auto overflow-hidden">
        <div class="px-6 py-4" :class="confirmModalColor">
          <div class="flex items-center">
            <div class="p-3 rounded-full bg-white bg-opacity-30 mr-4">
              <Icon :icon="confirmModalIcon" class="text-white text-2xl" />
            </div>
            <div>
              <h3 class="text-lg font-bold text-white">{{ confirmModalTitulo }}</h3>
              <p class="text-sm text-white text-opacity-90">{{ confirmModalSubtitulo }}</p>
            </div>
          </div>
        </div>
        
        <div class="px-6 py-5">
          <p class="text-gray-700 dark:text-gray-300 mb-2">{{ confirmModalMensaje }}</p>
          <p v-if="confirmModalDetalle" class="text-sm text-gray-500 dark:text-gray-400 mb-4">{{ confirmModalDetalle }}</p>

          <div v-if="confirmModalTipo === 'eliminar' && confirmModalMetodo" class="mb-4 p-3 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800">
            <div class="flex items-center">
              <Icon icon="mdi:alert-circle" class="text-red-600 dark:text-red-400 text-xl mr-2" />
              <div>
                <p class="font-medium text-gray-900 dark:text-white">{{ confirmModalMetodo.nombre }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">Tipo: {{ formatTipo(confirmModalMetodo.tipo) }}</p>
              </div>
            </div>
            <p class="mt-2 text-xs text-red-600 dark:text-red-400">
              <Icon icon="mdi:alert" class="inline mr-1" />
              Esta acción no se puede deshacer
            </p>
          </div>

          <div v-if="confirmModalTipo === 'toggle-status' && confirmModalMetodo" class="mb-4 p-3 rounded-lg" :class="confirmModalMetodo.estado?.toLowerCase() === 'activo' ? 'bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800' : 'bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800'">
            <div class="flex items-center">
              <Icon :icon="confirmModalMetodo.estado?.toLowerCase() === 'activo' ? 'mdi:close-circle' : 'mdi:check-circle'" class="text-xl mr-2" :class="confirmModalMetodo.estado?.toLowerCase() === 'activo' ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'" />
              <div>
                <p class="font-medium text-gray-900 dark:text-white">{{ confirmModalMetodo.nombre }}</p>
                <p class="text-xs text-gray-500 dark:text-gray-400">Estado actual: {{ confirmModalMetodo.estado }}</p>
              </div>
            </div>
            <p class="mt-2 text-xs">
              El método pasará a estado: 
              <span class="font-semibold" :class="confirmModalMetodo.estado?.toLowerCase() === 'activo' ? 'text-red-600 dark:text-red-400' : 'text-green-600 dark:text-green-400'">
                {{ confirmModalMetodo.estado?.toLowerCase() === 'activo' ? 'Inactivo' : 'Activo' }}
              </span>
            </p>
          </div>
        </div>
        
        <div class="px-6 py-4 bg-gray-50 dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 flex justify-end space-x-3">
          <button
            @click="cancelarConfirmacion"
            class="px-4 py-2 border-2 border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-100 dark:hover:bg-gray-800 transition-all duration-300 text-sm"
          >
            Cancelar
          </button>
          <button
            @click="ejecutarAccionConfirmada"
            class="px-4 py-2 rounded-lg text-white font-medium transition-all duration-300 text-sm flex items-center"
            :class="confirmModalButtonColor"
          >
            <Icon v-if="confirmModalCargando" icon="mdi:loading" class="animate-spin mr-2" />
            {{ confirmModalCargando ? 'Procesando...' : confirmModalBotonTexto }}
          </button>
        </div>
      </div>
    </div>
    </Teleport>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { debounce } from 'lodash';
import { useToast } from "vue-toastification";

// APIs de métodos de pago
import {
  obtenerMetodosPago,
  obtenerMetodosPagoActivos,
  obtenerMetodoPagoPorId,
  obtenerMetodoPagoConRelaciones,
  obtenerEstadisticasMetodoPago,
  crearMetodoPago,
  actualizarMetodoPago,
  cambiarEstadoMetodoPago,
  eliminarMetodoPago,
  verificarMetodoPagoExiste,
  validarNombreMetodoPago,
  obtenerMetodosPagoPorTipo,
  filtrarMetodosPagoPorMoneda,
  serializarCamposRequeridos,
  deserializarCamposRequeridos,
  obtenerTiposDisponibles
} from '@/api/metodosPago.api.js';

export default {
  name: 'MetodosPagoView',
  components: {
    Icon,
  },
  setup() {
    const toast = useToast();
    return { toast };
  },
  data() {
    return {
      // Datos principales
      metodosPago: [],
      tiposDisponibles: [],
      detalleMetodo: null,
      detalleEstadisticas: null,

      // UI States
      loading: false,
      saving: false,
      cargandoDetalles: false,
      showModal: false,
      showDetallesModal: false,
      showReportModal: false,
      showConfirmModal: false,
      reporteCargando: false,
      reporteMetodos: [],
      reporteTitulo: '',
      reporteSubtitulo: '',
      reporteVista: 'lista',

      // Filtros y búsqueda
      searchQuery: '',
      filterStatus: 'all',
      filterTipo: 'all',
      filterMoneda: 'all',
      sortBy: 'nombre',
      currentPage: 1,
      itemsPerPage: 6,
      lastUpdate: new Date(),

      // Formularios
      form: {
        idMetodoPago: null,
        nombre: '',
        descripcion: '',
        tipo: '',
        campos_requeridos: null,
        acepta_dolares: true,
        acepta_bolivares: true,
        acepta_usdt: false,
        estado: 'Activo'
      },
      camposSeleccionados: {
        referencia: false,
        banco_origen: false,
        banco_destino: false,
        numero_cuenta: false,
        cedula_titular: false,
        nombre_titular: false,
        telefono: false,
        email: false,
        wallet_address: false,
        red_blockchain: false
      },
      errors: {},
      editingMetodo: null,

      // Modales de confirmación
      confirmModalTipo: '',
      confirmModalTitulo: '',
      confirmModalSubtitulo: '',
      confirmModalMensaje: '',
      confirmModalDetalle: '',
      confirmModalIcon: '',
      confirmModalColor: '',
      confirmModalButtonColor: '',
      confirmModalBotonTexto: '',
      confirmModalMetodo: null,
      confirmModalCargando: false,
      confirmModalAccion: null,
    };
  },
  computed: {
    filteredMetodos() {
      let filtered = [...this.metodosPago];

      if (this.searchQuery.trim()) {
        const terminoLower = this.searchQuery.toLowerCase();
        filtered = filtered.filter(metodo => 
          (metodo.nombre && metodo.nombre.toLowerCase().includes(terminoLower)) ||
          (metodo.descripcion && metodo.descripcion?.toLowerCase().includes(terminoLower)) ||
          (metodo.tipo && metodo.tipo.toLowerCase().includes(terminoLower))
        );
      }

      if (this.filterStatus === 'activos') {
        filtered = filtered.filter(m => m.estado?.toLowerCase() === 'activo');
      } else if (this.filterStatus === 'inactivos') {
        filtered = filtered.filter(m => m.estado?.toLowerCase() === 'inactivo');
      }

      if (this.filterTipo !== 'all') {
        filtered = filtered.filter(m => m.tipo === this.filterTipo);
      }

      if (this.filterMoneda !== 'all') {
        if (this.filterMoneda === 'USD') {
          filtered = filtered.filter(m => m.acepta_dolares);
        } else if (this.filterMoneda === 'VES') {
          filtered = filtered.filter(m => m.acepta_bolivares);
        } else if (this.filterMoneda === 'USDT') {
          filtered = filtered.filter(m => m.acepta_usdt);
        }
      }

      // Ordenar
      if (this.sortBy === 'nombre') {
        filtered.sort((a, b) => a.nombre.localeCompare(b.nombre));
      } else if (this.sortBy === 'nombre_desc') {
        filtered.sort((a, b) => b.nombre.localeCompare(a.nombre));
      } else if (this.sortBy === 'tipo') {
        filtered.sort((a, b) => a.tipo.localeCompare(b.tipo));
      } else if (this.sortBy === 'fecha_desc') {
        filtered.sort((a, b) => new Date(b.fecha_creacion) - new Date(a.fecha_creacion));
      }

      return filtered;
    },

    paginatedMetodos() {
      const start = (this.currentPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.filteredMetodos.slice(start, end);
    },

    totalPages() {
      return Math.ceil(this.filteredMetodos.length / this.itemsPerPage);
    },

    visiblePages() {
      const pages = [];
      const maxVisible = 5;
      let start = Math.max(1, this.currentPage - Math.floor(maxVisible / 2));
      let end = Math.min(this.totalPages, start + maxVisible - 1);

      if (end - start + 1 < maxVisible) {
        start = Math.max(1, end - maxVisible + 1);
      }

      for (let i = start; i <= end; i++) {
        pages.push(i);
      }
      return pages;
    },

    startItem() {
      return (this.currentPage - 1) * this.itemsPerPage + 1;
    },

    endItem() {
      return Math.min(this.currentPage * this.itemsPerPage, this.filteredMetodos.length);
    },

    isFormValid() {
      return this.form.nombre.trim() && 
             this.form.tipo &&
             (this.form.acepta_dolares || this.form.acepta_bolivares || this.form.acepta_usdt);
    },
  },
  watch: {
    filterStatus() {
      this.currentPage = 1;
    },
    filterTipo() {
      this.currentPage = 1;
    },
    filterMoneda() {
      this.currentPage = 1;
    },
    searchQuery() {
      this.currentPage = 1;
    },
  },
  async mounted() {
    await this.cargarTiposDisponibles();
    await this.loadData();
  },
  methods: {
    // ========== MÉTODOS DE CARGA DE DATOS ==========
    async loadData() {
      this.loading = true;
      try {
        const response = await obtenerMetodosPago();
        
        if (response.success) {
          this.metodosPago = response.data || [];
          this.lastUpdate = new Date();
        } else {
          this.mostrarError(response.error || 'Error al cargar los métodos de pago');
        }
      } catch (error) {
        console.error('Error al cargar datos:', error);
        this.mostrarError('Error al cargar los datos');
      } finally {
        this.loading = false;
      }
    },

    async cargarTiposDisponibles() {
      try {
        const response = await obtenerTiposDisponibles();
        if (response.success) {
          this.tiposDisponibles = response.data || [];
        }
      } catch (error) {
        console.error('Error cargando tipos:', error);
      }
    },

    async cargarDetallesCompletos(id) {
      this.cargandoDetalles = true;
      try {
        const [detalleRes, estadisticasRes] = await Promise.all([
          obtenerMetodoPagoConRelaciones(id),
          obtenerEstadisticasMetodoPago(id)
        ]);

        if (detalleRes.success) {
          this.detalleMetodo = detalleRes.data;
        }

        if (estadisticasRes.success) {
          this.detalleEstadisticas = estadisticasRes.data;
        }
      } catch (error) {
        console.error('Error cargando detalles:', error);
        this.mostrarError('Error al cargar los detalles');
      } finally {
        this.cargandoDetalles = false;
      }
    },

    // ========== MÉTODOS DE CONFIRMACIÓN ==========
    abrirModalConfirmacion(config) {
      this.confirmModalTipo = config.tipo;
      this.confirmModalTitulo = config.titulo;
      this.confirmModalSubtitulo = config.subtitulo || '';
      this.confirmModalMensaje = config.mensaje;
      this.confirmModalDetalle = config.detalle || '';
      this.confirmModalIcon = config.icon || 'mdi:help-circle';
      this.confirmModalColor = config.color || 'bg-gradient-to-r from-blue-600 to-indigo-600';
      this.confirmModalButtonColor = config.buttonColor || 'bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700';
      this.confirmModalBotonTexto = config.botonTexto || 'Confirmar';
      this.confirmModalMetodo = config.metodo || null;
      this.confirmModalAccion = config.accion;
      this.showConfirmModal = true;
    },

    cancelarConfirmacion() {
      this.showConfirmModal = false;
      this.confirmModalCargando = false;
      this.confirmModalMetodo = null;
      this.confirmModalAccion = null;
    },

    async ejecutarAccionConfirmada() {
      if (this.confirmModalAccion) {
        this.confirmModalCargando = true;
        await this.confirmModalAccion(this.confirmModalMetodo);
        this.confirmModalCargando = false;
        this.cancelarConfirmacion();
      }
    },

    abrirModalEliminar(metodo) {
      this.abrirModalConfirmacion({
        tipo: 'eliminar',
        titulo: 'Eliminar Método de Pago',
        subtitulo: 'Esta acción no se puede deshacer',
        mensaje: `¿Estás seguro de eliminar "${metodo.nombre}"?`,
        detalle: 'El método de pago será eliminado permanentemente del sistema.',
        icon: 'mdi:alert-circle',
        color: 'bg-gradient-to-r from-red-600 to-pink-600',
        buttonColor: 'bg-gradient-to-r from-red-600 to-pink-600 hover:from-red-700 hover:to-pink-700',
        botonTexto: 'Eliminar',
        metodo: metodo,
        accion: this.deleteMetodoPago
      });
    },

    abrirModalToggleStatus(metodo) {
      const esActivo = metodo.estado?.toLowerCase() === 'activo';
      const nuevoEstado = esActivo ? 'Inactivo' : 'Activo';
      
      this.abrirModalConfirmacion({
        tipo: 'toggle-status',
        titulo: esActivo ? 'Desactivar Método' : 'Activar Método',
        subtitulo: `Cambiar estado del método`,
        mensaje: `¿Estás seguro de ${esActivo ? 'desactivar' : 'activar'} "${metodo.nombre}"?`,
        detalle: `El método pasará de "${metodo.estado}" a "${nuevoEstado}".`,
        icon: esActivo ? 'mdi:close-circle' : 'mdi:check-circle',
        color: esActivo ? 'bg-gradient-to-r from-red-600 to-orange-600' : 'bg-gradient-to-r from-green-600 to-emerald-600',
        buttonColor: esActivo ? 'bg-gradient-to-r from-red-600 to-orange-600 hover:from-red-700 hover:to-orange-700' : 'bg-gradient-to-r from-green-600 to-emerald-600 hover:from-green-700 hover:to-emerald-700',
        botonTexto: esActivo ? 'Desactivar' : 'Activar',
        metodo: metodo,
        accion: this.toggleStatus
      });
    },

    // ========== MÉTODOS DE TOAST ==========
    mostrarExito(mensaje) {
      this.toast.success(mensaje, { timeout: 3000 });
    },

    mostrarError(mensaje) {
      this.toast.error(mensaje, { timeout: 5000 });
    },

    mostrarAdvertencia(mensaje) {
      this.toast.warning(mensaje, { timeout: 4000 });
    },

    // ========== MÉTODOS DE FORMATEO ==========
    formatTipo(tipo) {
      const tipos = {
        'efectivo': 'Efectivo',
        'transferencia': 'Transferencia',
        'pago_movil': 'Pago Móvil',
        'tarjeta': 'Tarjeta',
        'transferencia_internacional': 'Transferencia Internacional',
        'cripto': 'Criptomoneda',
        'aplicacion_credito': 'Aplicación de Crédito'
      };
      return tipos[tipo] || tipo;
    },

    getTipoIcon(tipo) {
      const iconos = {
        'efectivo': 'mdi:cash',
        'transferencia': 'mdi:bank-transfer',
        'pago_movil': 'mdi:cellphone',
        'tarjeta': 'mdi:credit-card',
        'transferencia_internacional': 'mdi:bank',
        'cripto': 'mdi:bitcoin',
        'aplicacion_credito': 'mdi:application'
      };
      return iconos[tipo] || 'mdi:cash';
    },

    getTipoColor(tipo) {
      const colores = {
        'efectivo': 'from-green-600 to-emerald-600',
        'transferencia': 'from-blue-600 to-indigo-600',
        'pago_movil': 'from-purple-600 to-pink-600',
        'tarjeta': 'from-amber-600 to-orange-600',
        'transferencia_internacional': 'from-cyan-600 to-teal-600',
        'cripto': 'from-violet-600 to-purple-600',
        'aplicacion_credito': 'from-rose-600 to-red-600'
      };
      return colores[tipo] || 'from-gray-600 to-gray-700';
    },

    getCamposRequeridosArray(camposRequeridos) {
      if (!camposRequeridos) return [];
      
      try {
        const camposObj = JSON.parse(camposRequeridos);
        const nombresCampos = {
          'referencia': 'N° Referencia',
          'banco_origen': 'Banco Origen',
          'banco_destino': 'Banco Destino',
          'numero_cuenta': 'N° Cuenta',
          'cedula_titular': 'Cédula Titular',
          'nombre_titular': 'Nombre Titular',
          'telefono': 'Teléfono',
          'email': 'Email',
          'wallet_address': 'Wallet',
          'red_blockchain': 'Red Blockchain'
        };
        
        return Object.entries(camposObj)
          .filter(([key, value]) => value === true)
          .map(([key]) => nombresCampos[key] || key);
      } catch (e) {
        return [];
      }
    },

    formatNumber(numero, decimales = 2) {
      if (numero === null || numero === undefined) return '0';
      return new Intl.NumberFormat('es-VE', {
        minimumFractionDigits: decimales,
        maximumFractionDigits: decimales
      }).format(numero);
    },

    formatDate(fechaISO, completo = true) {
      if (!fechaISO) return '';
      try {
        const fecha = new Date(fechaISO);
        const opciones = {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit'
        };
        if (completo) {
          opciones.hour = '2-digit';
          opciones.minute = '2-digit';
        }
        return fecha.toLocaleDateString('es-VE', opciones);
      } catch (error) {
        return fechaISO;
      }
    },

    formatTime(fechaISO) {
      if (!fechaISO) return '';
      try {
        const fecha = new Date(fechaISO);
        return fecha.toLocaleTimeString('es-VE', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        });
      } catch (error) {
        return '';
      }
    },

    // ========== MÉTODOS DE FILTROS ==========
    handleFilterChange() {
      this.currentPage = 1;
    },

    handleSearch: debounce(function() {
      this.currentPage = 1;
    }, 300),

    clearFilters() {
      this.searchQuery = '';
      this.filterStatus = 'all';
      this.filterTipo = 'all';
      this.filterMoneda = 'all';
      this.sortBy = 'nombre';
      this.currentPage = 1;
    },

    // ========== MÉTODOS DE REPORTES ==========
    generarReporteGeneral() {
      this.reporteTitulo = 'REPORTE GENERAL DE MÉTODOS DE PAGO';
      this.reporteSubtitulo = `Todos los métodos (${this.metodosPago.length})`;
      this.reporteMetodos = this.metodosPago;
      this.reporteVista = 'lista';
      this.showReportModal = true;
    },

    generarReportePorFiltro(tipoFiltro, tituloPersonalizado = null) {
      let metodosFiltrados = [];
      
      if (tipoFiltro === 'activos') {
        metodosFiltrados = this.metodosPago.filter(m => m.estado?.toLowerCase() === 'activo');
      } else if (tipoFiltro === 'inactivos') {
        metodosFiltrados = this.metodosPago.filter(m => m.estado?.toLowerCase() === 'inactivo');
      } else {
        metodosFiltrados = this.metodosPago.filter(m => m.tipo === tipoFiltro);
      }
      
      if (metodosFiltrados.length === 0) {
        this.toast.warning('No hay métodos de pago que coincidan con este filtro');
        return;
      }
      
      this.reporteTitulo = tituloPersonalizado || `MÉTODOS DE PAGO: ${this.formatTipo(tipoFiltro).toUpperCase()}`;
      this.reporteSubtitulo = `Filtro: ${this.formatTipo(tipoFiltro)}`;
      this.reporteMetodos = metodosFiltrados;
      this.reporteVista = 'lista';
      this.showReportModal = true;
    },

    closeReportModal() {
      this.showReportModal = false;
      this.reporteMetodos = [];
      this.reporteVista = 'lista';
    },

    imprimirReporte() {
      // Aquí implementarías la lógica de impresión
      this.toast.info('Función de impresión en desarrollo');
    },

    // ========== MÉTODOS DEL MODAL ==========
    openCreateModal() {
      this.editingMetodo = null;
      this.resetForm();
      this.errors = {};
      this.showModal = true;
    },

    openEditModal(metodo) {
      this.editingMetodo = metodo;
      
      // Parsear campos requeridos si existen
      if (metodo.campos_requeridos) {
        try {
          this.camposSeleccionados = JSON.parse(metodo.campos_requeridos);
        } catch (e) {
          this.camposSeleccionados = {
            referencia: false,
            banco_origen: false,
            banco_destino: false,
            numero_cuenta: false,
            cedula_titular: false,
            nombre_titular: false,
            telefono: false,
            email: false,
            wallet_address: false,
            red_blockchain: false
          };
        }
      } else {
        this.resetCamposSeleccionados();
      }

      this.form = {
        idMetodoPago: metodo.idMetodoPago,
        nombre: metodo.nombre || '',
        descripcion: metodo.descripcion || '',
        tipo: metodo.tipo || '',
        campos_requeridos: metodo.campos_requeridos || null,
        acepta_dolares: metodo.acepta_dolares !== undefined ? metodo.acepta_dolares : true,
        acepta_bolivares: metodo.acepta_bolivares !== undefined ? metodo.acepta_bolivares : true,
        acepta_usdt: metodo.acepta_usdt !== undefined ? metodo.acepta_usdt : false,
        estado: metodo.estado || 'Activo'
      };
      
      this.errors = {};
      this.showModal = true;
    },

    abrirModalVerDetalles(metodo) {
      this.detalleMetodo = null;
      this.detalleEstadisticas = null;
      this.showDetallesModal = true;
      this.cargarDetallesCompletos(metodo.idMetodoPago);
    },

    closeModal() {
      this.showModal = false;
      this.resetForm();
      this.errors = {};
    },

    closeDetallesModal() {
      this.showDetallesModal = false;
      this.detalleMetodo = null;
      this.detalleEstadisticas = null;
    },

    resetForm() {
      this.form = {
        idMetodoPago: null,
        nombre: '',
        descripcion: '',
        tipo: '',
        campos_requeridos: null,
        acepta_dolares: true,
        acepta_bolivares: true,
        acepta_usdt: false,
        estado: 'Activo'
      };
      this.resetCamposSeleccionados();
      this.editingMetodo = null;
    },

    resetCamposSeleccionados() {
      this.camposSeleccionados = {
        referencia: false,
        banco_origen: false,
        banco_destino: false,
        numero_cuenta: false,
        cedula_titular: false,
        nombre_titular: false,
        telefono: false,
        email: false,
        wallet_address: false,
        red_blockchain: false
      };
    },

    // ========== VALIDACIONES ==========
    validateForm() {
      this.errors = {};

      if (!this.form.nombre.trim()) {
        this.errors.nombre = 'El nombre es requerido';
      }

      if (!this.form.tipo) {
        this.errors.tipo = 'El tipo es requerido';
      }

      if (!this.form.acepta_dolares && !this.form.acepta_bolivares && !this.form.acepta_usdt) {
        this.errors.monedas = 'Debe seleccionar al menos una moneda';
      }

      return Object.keys(this.errors).length === 0;
    },

    // ========== MÉTODOS CRUD ==========
    async saveMetodoPago() {
      if (!this.validateForm()) return;

      this.saving = true;
      try {
        // Serializar campos requeridos
        const camposRequeridosJson = JSON.stringify(this.camposSeleccionados);

        const metodoData = {
          nombre: this.form.nombre.trim(),
          descripcion: this.form.descripcion?.trim() || null,
          tipo: this.form.tipo,
          campos_requeridos: camposRequeridosJson,
          acepta_dolares: this.form.acepta_dolares,
          acepta_bolivares: this.form.acepta_bolivares,
          acepta_usdt: this.form.acepta_usdt,
          estado: this.form.estado
        };

        let result;
        if (this.editingMetodo) {
          result = await actualizarMetodoPago(this.editingMetodo.idMetodoPago, metodoData);
        } else {
          result = await crearMetodoPago(metodoData);
        }

        if (result.success) {
          await this.loadData();
          await this.cargarTiposDisponibles();
          this.closeModal();
          this.mostrarExito(this.editingMetodo ? '¡Método de pago actualizado!' : '¡Método de pago creado!');
        } else {
          throw new Error(result.error || 'Error al guardar el método de pago');
        }
      } catch (error) {
        console.error('Error al guardar:', error);
        this.mostrarError(error.message || 'Error al guardar el método de pago');
      } finally {
        this.saving = false;
      }
    },

    async deleteMetodoPago(metodo) {
      try {
        const result = await eliminarMetodoPago(metodo.idMetodoPago);
        if (result.success) {
          await this.loadData();
          await this.cargarTiposDisponibles();
          this.mostrarExito('¡Método de pago eliminado exitosamente!');
        } else {
          throw new Error(result.error || 'Error al eliminar el método de pago');
        }
      } catch (error) {
        console.error('Error al eliminar:', error);
        this.mostrarError(error.message || 'Error al eliminar el método de pago');
      }
    },

    async toggleStatus(metodo) {
      try {
        const esActivo = metodo.estado?.toLowerCase() === 'activo';
        const nuevoEstado = esActivo ? 'Inactivo' : 'Activo';
        const result = await cambiarEstadoMetodoPago(metodo.idMetodoPago, nuevoEstado);

        if (result.success) {
          await this.loadData();
          this.mostrarExito(`¡Método de pago ${nuevoEstado.toLowerCase()} exitosamente!`);
        } else {
          throw new Error(result.error || 'Error al cambiar el estado');
        }
      } catch (error) {
        console.error('Error al cambiar estado:', error);
        this.mostrarError('Error al cambiar el estado');
      }
    }
  }
};
</script>

<style scoped>
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.fade-in {
  animation: fadeIn 0.3s ease-out;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.dark ::-webkit-scrollbar-track {
  background: #374151;
}

.dark ::-webkit-scrollbar-thumb {
  background: #6b7280;
}

.dark ::-webkit-scrollbar-thumb:hover {
  background: #9ca3af;
}

@media (max-width: 768px) {
  button {
    min-height: 44px;
  }
  
  input, select, textarea {
    font-size: 16px !important;
  }
}
</style>